import { Component, input, inject, LOCALE_ID, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, ControlContainer, FormGroup } from '@angular/forms';
import { LookupItem } from '../product-info-step.model';
import { RefrigeratorToggale } from '../refrigerator-toggale/refrigerator-toggale';
import { DropdownArrow } from '../../../../../../shared/ui/icons/dropdown-arrow/dropdown-arrow';

@Component({
  selector: 'app-product-basic-info',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RefrigeratorToggale, DropdownArrow],
  templateUrl: './product-basic-info.html',
  styleUrl: './product-basic-info.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
})
export class ProductBasicInfo {
  private localeId = inject(LOCALE_ID);
  private container = inject(ControlContainer);

  hasSubProducts = input.required<boolean>();
  mfgCompanies = input.required<LookupItem[]>();
  categories = input.required<LookupItem[]>();
  subCategories = input.required<LookupItem[]>();

  isRefrigerated = signal<boolean>(false);

  get form(): FormGroup {
    return this.container.control as FormGroup;
  }

  onRefrigeratorToggle(val: boolean): void {
    this.isRefrigerated.set(val);
    this.form.get('isRefrigerated')?.setValue(val);
    this.form.get('isRefrigerated')?.markAsTouched();
  }

  isArabic = () => document.documentElement.dir === 'rtl';

  err(field: string, errorKey: string): boolean {
    const ctrl = this.form.get(field);
    return !!(ctrl?.hasError(errorKey) && ctrl?.touched);
  }

  invalid(field: string): boolean {
    const ctrl = this.form.get(field);
    return !!(ctrl?.invalid && ctrl?.touched);
  }
}
